export const REPORT_STATUS = {
    INITIAL: 'initial',
    PROCESSING: 'processing',
    OPTIMIZED: 'optimized',
    FINISHED: 'finished',
    STOPPED: 'stopped',
    ALL_STOPPED: 'all_stopped',
    FAILED: 'failed',
} as const;

export type SearchAction = 'restart' | 'resume' | 'stop' | null;

const RESTARTABLE: string[] = [REPORT_STATUS.FINISHED];

const RESUMABLE: string[] = [
    REPORT_STATUS.STOPPED,
    REPORT_STATUS.ALL_STOPPED,
    REPORT_STATUS.FAILED,
];

const STOPPABLE: string[] = [REPORT_STATUS.PROCESSING, REPORT_STATUS.OPTIMIZED];